<template>
  <div class="manifest-info">
    <el-form
      ref="myForm"
      :model="form"
      :disabled="!isEdit"
      label-width="120px"
      label-position="right"
      :rules="rules"
    >
      <el-form-item :class="labelStyle" label="MB/L NO" prop="mbl">
        <div style="display: flex">
          <el-tooltip :content="$t('CargoMsg.Cargo_canOnlyBeUppercaseCharactersAndNumbers')" placement="bottom" effect="light">
            <el-input ref="mbl" v-model="form.mblNo" :placeholder="(isSeaHouseChannel || isWseChannel || isRongeTong) && isEdit ? $t('CargoMsg.Cargo_canOnlyBeUppercaseCharactersAndNumbers') : ''" class="short" :disabled="(isSeaHouseChannel || isWseChannel || isRongeTong) && isSent" @blur="mblCheck" @change="mblCheck" />
          </el-tooltip>
          <img src="@/assets/icons/log.png" style="height: 28px; margin-left: 5px; cursor:pointer" @click="handleReceipt">
        </div>
      </el-form-item>
      <!-- 船名 -->
      <el-form-item :class="labelStyle" :label="$t('SeaExport.Vessel')" prop="bargeVessel">
        <el-tooltip :content="$t('CargoMsg.Cargo_pleaseEnterTheNameOfTheShipOnlyUppercaseCharactersAndNumbers')" placement="bottom" effect="light">
          <cargo-advance-select
            :disabled="(isSeaHouseChannel || isWseChannel || isRongeTong) && isSent"
            :select-type="selectTypeNames.static_data_Vessel"
            filterable
            :default-value="form.bargeVessel"
            :static-options="vesselList"
            :allow-create="true"
            :class="importDifferenceField.bargeVessel ? 'red-border' : ''"
            :placeholder="(isSeaHouseChannel || isWseChannel || isRongeTong) ? $t('CargoMsg.Cargo_pleaseEnterTheNameOfTheShipOnlyUppercaseCharactersAndNumbers') : ''"
            @parentCallBack="p=>{onVesselSelectionChange(p);vesselCheck()}"
          />
        </el-tooltip>
      </el-form-item>
      <!-- 航次 -->
      <el-form-item :class="labelStyle" :label="$t('SeaExport.Voyage')" prop="voyage">
        <cargo-advance-select
          ref="voyageFlight"
          :disabled="(isSeaHouseChannel || isWseChannel || isRongeTong) && isSent"
          :static-options="optionsVoyages || []"
          :cache="false"
          :default-value="form.bargeVoyage"
          filterable
          clearable
          :allow-create="editVoyageMode"
          :filter-tag-names="['voyageNo']"
          tag-name="voyageNo"
          tag-value="voyageNo"
          :class="importDifferenceField.bargeVoyage ? 'red-border' : ''"
          :placeholder="(isSeaHouseChannel || isWseChannel || isRongeTong) ? $t('CargoMsg.Cargo_enterTheVoyageThereCanBeNoV') : $t('CargoMsg.Cargo_inputVoyage')"
          @focus="txtVoyageFocusInHandler"
          @parentCallBack="onVoyageFlightChange"
        />
      </el-form-item>
      <el-form-item v-show="!isSeaHouseChannel && !isWseChannel && !isRongeTong" :class="labelStyle" :label="$t('SeaExport.ShippingCompany')">
        <el-tooltip :content="$t('CargoMsg.Cargo_enterTheVoyageThereCanBeNoV')" placement="bottom" effect="light">
          <cargo-company-select
            filterable
            :disabled="isSeaHouseChannel && isSent"
            :method-params="{seaCmp:true}"
            :select-type="selectTypeNames.basic_data_Company"
            :default-value="form.shippingCompany||''"
            :allow-create="false"
            :class="importDifferenceField.shippingCompany ? 'red-border' : ''"
            @change="p=>form.shippingCompany=p.value"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-show="isSeaHouseChannel || isWseChannel || isRongeTong" :class="labelStyle" :label="$t('SeaExport.ShippingCompany')" prop="thirdPartyCarrier">
        <el-tooltip :content="$t('CargoMsg.Cargo_pleaseSelectAShippingCompany')" placement="bottom" effect="light">
          <cargo-advance-select
            :disabled="isSent"
            :static-options="getOptions('carrierCompanyList')"
            :cache="false"
            :default-value="form.thirdPartyCarrier"
            filterable
            clearable
            :filter-tag-names="['name', 'code', 'chineseName']"
            tag-name="name"
            tag-value="code"
            :placeholder="$t('SeaExport.PleaseSelectShippingCompany')"
            @parentCallBack="p=>{form.thirdPartyCarrier=p.value;changeThirdPartyCarrier();}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-show="!isSeaHouseChannel && !isWseChannel && !isRongeTong" :class="labelStyle" :label="$t('SeaExport.CarrierAgent')">
        <el-tooltip :content="$t('CargoMsg.Cargo_pleaseSelectAShippingGeneration')" placement="bottom" effect="light">
          <cargo-company-select
            :disabled="isSeaHouseChannel && isSent"
            :method-params="{seaCmpAgent:true,companyLob:'seaExport',active:true}"
            :default-value="form.carrierAgent"
            :allow-create="false"
            :class="importDifferenceField.carrierAgent ? 'red-border' : ''"
            @change="p=>{form.carrierAgent=p.value}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-show="isSeaHouseChannel || isWseChannel || isRongeTong" :class="labelStyle" :label="$t('SeaExport.CarrierAgent')" prop="thirdPartyCarrierAgent">
        <el-tooltip :content="$t('CargoMsg.Cargo_pleaseSelectAShippingGeneration')" placement="bottom" effect="light">
          <cargo-advance-select
            :disabled="isSent"
            :static-options="getOptions('carrierAgentCompanyList')"
            :cache="false"
            :default-value="form.thirdPartyCarrierAgent"
            filterable
            clearable
            :filter-tag-names="['name', 'code', 'chineseName']"
            tag-name="name"
            tag-value="code"
            :placeholder="$t('CargoMsg.Cargo_pleaseSelectAShippingGeneration')"
            @parentCallBack="p=>{form.thirdPartyCarrierAgent=p.value}"
          />
        </el-tooltip>
      </el-form-item>

      <!-- 起运港 -->
      <el-form-item v-show="!isSeaHouseChannel && !isWseChannel && !isRongeTong" :class="labelStyle" :label="$t('SeaExport.PortOfLoadingAI')">
        <el-tooltip :content="$t('CargoMsg.Cargo_PortOfLoadingTip')" placement="bottom" effect="light">
          <cargo-advance-select
            :select-type="selectTypeNames.basic_data_Seaport"
            filterable
            :default-value="form.portOfLoading"
            tag-name="englishName"
            :class="importDifferenceField.portOfLoading ? 'red-border' : ''"
            @parentCallBack="p=>{form.portOfLoading = p.value;}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-show="isSeaHouseChannel || isWseChannel || isRongeTong" :class="labelStyle" :label="$t('SeaExport.PortOfLoadingAI')" prop="portOfLoading">
        <el-tooltip :content="$t('CargoMsg.Cargo_PortOfLoadingTip')" placement="bottom" effect="light">
          <cargo-advance-select
            :disabled="(isSeaHouseChannel || isWseChannel || isRongeTong) && isSent"
            :static-options="getOptions('portOfLoadingSeaports')"
            filterable
            :cache="false"
            :default-value="form.portOfLoading"
            tag-name="name"
            tag-value="code"
            :filter-tag-names="['name', 'code']"
            :placeholder="$t('CargoMsg.Cargo_PortOfLoadingTip')"
            :custom-label="(item)=>item ? `${item.name}|${item.code}` : ``"
            @parentCallBack="p=>{portOfLoadingHandler(p);}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-show="!isSeaHouseChannel && !isWseChannel && !isRongeTong" :class="labelStyle" :label="$t('CargoMsg.Cargo_PortOfDischarge')">
        <el-tooltip :content="$t('CargoMsg.Cargo_PortOfDischargeTipText')" placement="bottom" effect="light">
          <cargo-advance-select
            :select-type="selectTypeNames.basic_data_Seaport"
            filterable
            :default-value="form.portOfDischarge"
            :class="importDifferenceField.portOfDischarge ? 'red-border' : ''"
            @parentCallBack="p=>{form.portOfDischarge = p.value}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-show="isSeaHouseChannel || isWseChannel || isRongeTong" :class="labelStyle" :label="$t('CargoMsg.Cargo_PortOfDischarge')" prop="portOfDischarge">
        <el-tooltip :content="$t('CargoMsg.Cargo_PortOfDischargeTipText')" placement="bottom" effect="light">
          <cargo-advance-select
            :static-options="isOocl ? getOptions('ooclSeaports') : getOptions('seaports')"
            filterable
            :cache="false"
            :default-value="form.portOfDischarge"
            tag-name="name"
            tag-value="code"
            :filter-tag-names="['name', 'code']"
            :custom-label="(item)=>item ? `${item.name}|${item.code}` : ``"
            :placeholder="$t('CargoMsg.Cargo_PortOfDischargeTipText')"
            @parentCallBack="p=>{form.portOfDischarge = p.value}"
          />
        </el-tooltip>
      </el-form-item>

      <el-form-item v-show="!isSeaHouseChannel && !isWseChannel && !isRongeTong" :class="labelStyle" :label="$t('SeaExport.PortOfDestination')">
        <el-tooltip :content="$t('CargoMsg.Cargo_PortOfDestinationTip2')" placement="bottom" effect="light">
          <cargo-advance-select
            :select-type="selectTypeNames.basic_data_Seaport"
            filterable
            :default-value="form.portOfDestination"
            :class="importDifferenceField.portOfDestination ? 'red-border' : ''"
            @parentCallBack="p=>{form.portOfDestination = p.value}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-show="isSeaHouseChannel || isWseChannel || isRongeTong" :class="labelStyle" :label="$t('SeaExport.PortOfDestination')" prop="portOfDestination">
        <el-tooltip :content="$t('CargoMsg.Cargo_PortOfDestinationTip2')" placement="bottom" effect="light">
          <cargo-advance-select
            :static-options="getOptions('seaports')"
            filterable
            :cache="false"
            :default-value="form.portOfDestination"
            tag-name="name"
            tag-value="code"
            :filter-tag-names="['name', 'code']"
            :custom-label="(item)=>item ? `${item.name}|${item.code}` : ``"
            :placeholder="$t('CargoMsg.Cargo_PortOfDestinationTip2')"
            @parentCallBack="p=>{form.portOfDestination = p.value}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-show="!isSeaHouseChannel && !isWseChannel && !isRongeTong" :class="labelStyle" :label="$t('SeaExport.CargoType')">
        <el-tooltip :content="$t('CargoMsg.Cargo_pleaseSelectTheTypeOfGoods')" placement="bottom" effect="light">
          <cargo-advance-select
            :select-type="selectTypeNames.basic_data_CargoType"
            :method-params="{sea:true}"
            filterable
            :clearable="false"
            :default-value="form.cargoType"
            :class="importDifferenceField.cargoType ? 'red-border' : ''"
            @parentCallBack="p=>{form.cargoType=p.value}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-show="isSeaHouseChannel || isWseChannel || isRongeTong" :class="labelStyle" :label="$t('SeaExport.CargoType')" prop="cargoType">
        <el-tooltip :content="$t('CargoMsg.Cargo_pleaseSelectTheTypeOfGoods')" placement="bottom" effect="light">
          <cargo-advance-select
            :static-options="getOptions('cargoTypes')"
            :cache="false"
            :default-value="form.thirdPartyCargoType"
            filterable
            :filter-tag-names="['name', 'code', 'chineseName']"
            tag-name="name"
            tag-value="code"
            :placeholder="$t('CargoMsg.Cargo_pleaseSelectTheTypeOfGoods')"
            @parentCallBack="p=>{form.thirdPartyCargoType=p.value}"
          />
        </el-tooltip>
      </el-form-item>
      <!-- 运输条款 -->
      <el-form-item v-show="!(isWseChannel || isSeaHouseChannel || (isRongeTong && isShangHai))" :class="labelStyle" :label="$t('SeaExport.TransportationClause')">
        <el-tooltip :content="$t('CargoMsg.Cargo_InputBLFreightTermTootip')" placement="bottom" effect="light">
          <el-input v-show="isSent && !isWseChannel && !isRongeTong" v-model="form.masterBLFreightTermTootip" disabled />
          <cargo-advance-select
            v-show="!(isSeaHouseChannel || isWseChannel || isRongeTong) && !isSent"
            :select-type="selectTypeNames.basic_data_ShippingTerm"
            filterable
            :clearable="false"
            :default-value="form.masterBLFreightTermTootip"
            :class="importDifferenceField.masterBLFreightTermTootip ? 'red-border' : ''"
            @parentCallBack="p=>{form.masterBLFreightTermTootip=p.value}"
          />
          <cargo-advance-select
            v-show="isSeaHouseChannel || (isRongeTong && !isShangHai)"
            :disabled="isSeaHouseChannel"
            :static-options="getOptions('shippingTerms')"
            :cache="false"
            :default-value="form.thirdPartyFreightTerm"
            filterable
            :filter-tag-names="['name', 'code', 'chineseName']"
            tag-name="name"
            tag-value="code"
            @parentCallBack="p=>{form.thirdPartyFreightTerm=p.value}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-show="!(isSeaHouseChannel||isWseChannel||isRongeTong)" :class="labelStyleExcludeWse" :label="$t('SeaExport.FreightTerm')">
        <el-tooltip :content="$t('CargoMsg.Cargo_pleaseSelectShippingTerms')" placement="bottom" effect="light">
          <cargo-advance-select
            :select-type="selectTypeNames.basic_data_PaymentTerm"
            filterable
            :clearable="false"
            :default-value="form.masterBLFreightTerm"
            :class="importDifferenceField.masterBLFreightTerm ? 'red-border' : ''"
            @parentCallBack="p=>{form.masterBLFreightTerm=p.value}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-show="isSeaHouseChannel || isWseChannel || isRongeTong" :class="labelStyle" :label="$t('SeaExport.FreightTerm')" prop="thirdPartyPaymentMethod">
        <el-tooltip :content="$t('CargoMsg.Cargo_pleaseSelectShippingTerms')" placement="bottom" effect="light">
          <cargo-advance-select
            :static-options="getOptions('paymentTerms')"
            :cache="false"
            :default-value="form.thirdPartyPaymentMethod"
            filterable
            :filter-tag-names="['name', 'code', 'chineseName']"
            tag-name="name"
            tag-value="code"
            :placeholder="$t('CargoMsg.Cargo_pleaseSelectShippingTerms')"
            @parentCallBack="p=>{form.thirdPartyPaymentMethod=p.value}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item :class="(isWseChannel || isRongeTong) ? 'required-label' : ''" :label="$t('SeaExport.DateOfDeparture')" prop="sailingDate">
        <el-date-picker
          v-model="form.sailingDate"
          sailing-date
          type="date"
          value-format="yyyy-MM-dd"
          :class="importDifferenceField.sailingDate ? 'red-border' : ''"
          :placeholder="$t('CargoMsg.Cargo_SailingDateTip')"
        />
      </el-form-item>
      <el-form-item :class="labelStyle" :label="$t('SeaExport.BlType')" prop="thirdPartyBlType">
        <el-select
          v-show="!(isSeaHouseChannel|| isWseChannel || isRongeTong)"
          v-model="form.blType"
          :class="importDifferenceField.blType ? 'red-border' : ''"
          @change="val=>{cmbreleaseTypeMBLChangeHandler(val)}"
        >
          <el-option
            v-for="(item) in blModeList"
            :key="item.code"
            :label="item.name"
            :value="item.serialNumber"
          />
        </el-select>
        <el-tooltip :content="$t('CargoMsg.Cargo_BlNumberTip')" placement="bottom" effect="light">
          <cargo-advance-select
            v-show="isSeaHouseChannel || isWseChannel || isRongeTong"
            :static-options="getOptions('blModeList')"
            :cache="false"
            :default-value="form.thirdPartyBlType"
            filterable
            :filter-tag-names="['name', 'code', 'chineseName']"
            tag-name="name"
            tag-value="code"
            :placeholder="$t('CargoMsg.Cargo_BlNumberTip')"
            @parentCallBack="p=>{form.thirdPartyBlType=p.value}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-show="!isWseChannel&&!isSeaHouseChannel" :class="labelStyle" :label="$t('SeaExport.NoOfOriginalBls')" prop="blNumber">
        <el-tooltip :content="$t('CargoMsg.Cargo_PureNumbers')" placement="bottom" effect="light">
          <el-input v-model="form.blNumber" :class="importDifferenceField.blNumber ? 'red-border' : ''" :placeholder="isRongeTong && isEdit ? $t('CargoMsg.Cargo_PureNumbers') : ''" />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-show="!isWseChannel&&!isSeaHouseChannel&&!isRongeTong" :label="$t('SeaExport.PlaceOfPayment')">
        <el-input v-model="form.placeOfPayment" :class="importDifferenceField.placeOfPayment ? 'red-border' : ''" :placeholder="(isSeaHouseChannel || isWseChannel ||isRongeTong) && isEdit ? $t('CargoMsg.Cargo_pleaseEnterTheFullEnglishNameOfThePortInCapitalLetters') : ''" />
      </el-form-item>
      <el-form-item v-show="!isWseChannel && !isSeaHouseChannel && !isRongeTong" :class="labelStyleExcludeWse" :label="$t('SeaExport.PlaceOfIssue')">
        <el-tooltip :content="$t('CargoMsg.Cargo_DefaultShanghai')" placement="bottom" effect="light">
          <el-input v-model="form.signPlaceBL" :disabled="(isSeaHouseChannel || isWseChannel)" />
        </el-tooltip>
      </el-form-item>
      <el-form-item :label="$t('SeaExport.DateOfIssue')">
        <el-date-picker
          v-model="form.signDateBL"
          type="date"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item :class="labelStyle" :label="$t('SeaExport.PlaceOfReceipt')" prop="dispatchingPlaceCode">
        <el-tooltip :content="$t('CargoMsg.Cargo_DispatchingPlaceCodeTip')" placement="bottom" effect="light">
          <cargo-advance-select
            v-show="!isSeaHouseChannel && !isWseChannel && !isRongeTong"
            :select-type="selectTypeNames.basic_data_Seaport"
            filterable
            :default-value="form.dispatchingPlaceCode"
            tag-name="englishName"
            :class="importDifferenceField.dispatchingPlaceCode ? 'red-border' : ''"
            @parentCallBack="p=>{form.dispatchingPlaceCode = p.value}"
          />
          <cargo-advance-select
            v-show="isSeaHouseChannel || isWseChannel || isRongeTong"
            :static-options="getOptions('placeOfDispatchSeaports')"
            filterable
            :cache="false"
            :default-value="form.dispatchingPlaceCode"
            tag-name="name"
            tag-value="code"
            :class="importDifferenceField.dispatchingPlaceCode ? 'red-border' : ''"
            :filter-tag-names="['name', 'code']"
            :custom-label="(item)=>item ? `${item.name}|${item.code}` : ``"
            :placeholder="$t('CargoMsg.Cargo_pleaseEnterTheFullEnglishNameOfThePortInCapitalLetters')"
            @parentCallBack="p=>{form.dispatchingPlaceCode = p.value}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-show="isWseChannel && isOocl && (isShangHai || isQingDao)" :label="$t('CargoMsg.Cargo_IMO')" prop="dispatchingImo">
        <el-input v-model="form.imo" :placeholder="''" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'

import { ManifestInfo } from '@/class/model/booking/ManifestInfo'
import { Voyage } from '@/class/model/mdm/Voyage'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { loadSpecificBasicInfo } from '@/api/cache'
import { Job } from '@/class/model/booking/Job'
import { PrePlanBookingUtil } from '@/class/cargo/model/utils/PrePlanBookingUtil'
import * as PrePlanUtil from '@/class/cargo/model/utils/PrePlanBookingUtil'
import { ThirdPartyMappingUtil } from '@/class/cargo/model/utils/ThirdPartyMappingUtil'
import { validUserCode } from '@/utils/validate'
import { queryListByChannelDataType } from '@/api/basicData/thirdPartyMapping'

// import { TabError } from '@/utils/class/TabError'

export default {
  name: 'ManifestInfoBase',
  components: {
    cargoAdvanceSelect,
    cargoCompanySelect
  },
  props: {
    manifestInfos: {
      type: Array,
      default: () => []
    },
    manifestInfo: {
      type: Object,
      required: true
    },
    job: {
      type: Object,
      default: () => {}
    },
    context: {
      type: Object,
      required: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      required: true
    },
    channel: {
      type: Number,
      default: 0
    }
  },
  data() {
    var validatorMbl = (rule, value, callback) => {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        if (!validUserCode(this.form.mblNo) || this.form.mblNo.length < 6 || this.form.mblNo.length > 30) {
          return callback(new Error(this.$t('CargoMsg.Cargo_MblTip')))
        }
      } else {
        if (this.job.mbl && this.form.mblNo && this.job.mbl !== this.form.mblNo) {
          return callback(new Error(this.$t('CargoMsg.Cargo_CheckMblSame')))
        }
      }
    }
    var validatorVessel = (rule, value, callback) => {
      if (this.action === 'look') {
        return
      }
      if (this.isSeaHouseChannel || this.isWseChannel) {
        if (!(this.form.bargeVessel.length > 0 && /^[a-zA-Z0-9.\-\s]+$/.test(this.form.bargeVessel))) {
          return callback(new Error(this.$t('CargoMsg.Cargo_VesselTip')))
        }
      }
      if (this.isRongeTong) {
        if (this.form.bargeVessel && /[\u4E00-\u9FFF\u3000-\u303F\uFF00-\uFFEF]/.test(this.form.bargeVessel)) {
          return callback(new Error(this.$t('CargoMsg.Cargo_VesselTip2')))
        }
      }
    }
    var validatorVoyage = (rule, value, callback) => {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        if (!(this.form.bargeVoyage.length > 0 && !this.form.bargeVoyage.includes('V.'))) {
          return callback(new Error(this.$t('CargoMsg.Cargo_VoyageTip')))
        }
      }
    }
    var validatorThirdPartyCarrier = (rule, value, callback) => {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        if (!this.form.thirdPartyCarrier.length > 0) {
          return callback(new Error(this.$t('CargoMsg.Cargo_ShippingCompanyTip')))
        }
      }
    }
    var validatorThirdPartyCarrierAgent = (rule, value, callback) => {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        if (!this.form.thirdPartyCarrierAgent.length > 0) {
          return callback(new Error(this.$t('CargoMsg.Cargo_CarrierAgentTip')))
        }
      }
    }
    var validatorPortOfLoading = (rule, value, callback) => {
      if (this.isSeaHouseChannel) {
        if (!this.isShangHai) {
          return callback(new Error(this.$t('CargoMsg.Cargo_PortOfLoadingHgjTip')))
        }
      }
      if (this.isWseChannel || this.isRongeTong) {
        if (!(this.isShangHai || this.isQingDao)) {
          return callback(new Error(this.$t('CargoMsg.Cargo_PortOfLoadingWsTip')))
        }
      }
    }
    var validatorPortOfDischarge = (rule, value, callback) => {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        if (!this.form.portOfDischarge.length > 0) {
          return callback(new Error(this.$t('CargoMsg.Cargo_PortOfDischargeTip')))
        }
      }
    }
    var validatorPortOfDestination = (rule, value, callback) => {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        if (!this.form.portOfDestination.length > 0) {
          return callback(new Error(this.$t('CargoMsg.Cargo_PortOfDestinationTip')))
        }
      }
    }
    var validatorCargoType = (rule, value, callback) => {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        if (!this.form.thirdPartyCargoType.length > 0) {
          return callback(new Error(this.$t('CargoMsg.Cargo_pleaseSelectTheTypeOfGoods')))
        }
      }
    }
    var validatorThirdPartyPaymentMethod = (rule, value, callback) => {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        if (!this.form.thirdPartyPaymentMethod.length > 0) {
          return callback(new Error(this.$t('CargoMsg.Cargo_pleaseSelectShippingTerms')))
        }
      }
    }
    var validatorThirdPartyBlType = (rule, value, callback) => {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        if (!this.form.thirdPartyBlType.length > 0) {
          return callback(new Error(this.$t('CargoMsg.Cargo_BlNumberTip')))
        }
      }
    }
    var validatorSailingDate = (rule, value, callback) => {
      if (this.isWseChannel || this.isRongeTong) {
        if (!this.form.sailingDate) {
          return callback(new Error(this.$t('CargoMsg.Cargo_SailingDateTip')))
        }
      }
    }
    var validatorDispatchingPlaceCode = (rule, value, callback) => {
      if (this.isSeaHouseChannel) {
        if (!this.form.dispatchingPlaceCode.length > 0) {
          return callback(new Error(this.$t('CargoMsg.Cargo_DispatchingPlaceCodeTip2')))
        }
      }
      if (this.isWseChannel || this.isRongeTong) {
        if (!this.form.dispatchingPlaceCode.length > 0) {
          if (this.isShangHai) {
            return callback(new Error(this.$t('CargoMsg.Cargo_DispatchingPlaceCodeTip2')))
          } else {
            return callback(new Error(this.$t('CargoMsg.Cargo_DispatchingPlaceCodeTip3')))
          }
        }
      }
    }
    var validatorImo = (rule, value, callback) => {
      if (this.isWseChannel) {
        if (!this.form.imo.length > 0) {
          return callback(new Error(this.$t('CargoMsg.Cargo_InputIMO')))
        }
      }
    }
    var blNumber = (rule, value, callback) => {
      if (this.isRongeTong) {
        if (!this.form.blNumber) {
          return callback(new Error(this.$t('CargoMsg.Cargo_CanNotEmpty')))
        } else {
          const blNumberRegex = /^\d+$/
          if (!blNumberRegex.test(this.form.blNumber)) {
            return callback(new Error(this.$t('CargoMsg.Cargo_PureNumbers')))
          }
        }
      }
    }
    return {
      form: new ManifestInfo().fillDefaultValue().getData(),
      commonInfo: {
        combinedManifest: false,
        showSeaHouseChannel: true // 是否需要海管家
      },
      selectTypeNames: TYPE_NAMES,
      allowEditingVessel: false,
      currentVessel: null,
      vesselList: [],
      carrierAgentCompanyList: [], // 船代
      shippingTerms: [], // 运输条款
      carrierCompanyList: [], // 船公司
      cargoTypes: [], // 货物类型
      paymentTerms: [], // 运费条款
      optionsVoyages: [],
      showJudgmentOfVoyageNo: false, // 航次是否显示V.判断
      editVoyageMode: false, // 航次录入控制
      blModeList: [],
      isSent: false, // 是否已发送过舱单
      seaHouseCache: {
        load: false,
        carrierAgentCompanyList: [], // 船代
        shippingTerms: [], // 运输条款
        carrierCompanyList: [], // 船公司
        cargoTypes: [], // 货物类型
        paymentTerms: [], // 运费条款
        seaports: [], // 海港
        ooclSeaports: [], // OOCL海港
        blModeList: [], // 提单方式
        portOfLoadingSeaports: [], // 起运港海港
        placeOfDispatchSeaports: [] // 发货地海港
      },
      wseCache: {
        load: false,
        carrierAgentCompanyList: [], // 船代
        carrierCompanyList: [], // 船公司
        cargoTypes: [], // 货物类型
        seaports: [], // 海港
        portOfLoadingSeaports: [], // 起运港海港
        placeOfDispatchSeaports: [], // 发货地海港
        ooclSeaports: [], // OOCL海港
        blModeList: [] // 提单方式
      },
      rongeTong: {
        load: false,
        carrierAgentCompanyList: [], // 船代
        carrierCompanyList: [], // 船公司
        cargoTypes: [], // 货物类型
        shippingTerms: [], // 运输条款
        paymentTerms: [], // 运费条款
        seaports: [], // 海港
        ooclSeaports: [], // OOCL海港
        blModeList: [], // 提单方式
        portOfLoadingSeaports: [], // 起运港海港
        placeOfDispatchSeaports: [], // 发货地海港
        placeOfDispatchSeaportsQd: [
          { code: 'CNTAO', name: 'QINGDAO' },
          { code: 'CNRZH', name: 'RIZHAO' }
        ] // 青岛发货地数据源
      },
      thirdPartyMappingUtil: null,
      rules: {
        mbl: [
          { validator: validatorMbl, trigger: 'blur' }
        ],
        bargeVessel: [
          { validator: validatorVessel, trigger: 'change' }
        ],
        voyage: [
          { validator: validatorVoyage, trigger: 'change' }
        ],
        thirdPartyCarrier: [
          { validator: validatorThirdPartyCarrier, trigger: 'change' }
        ],
        thirdPartyCarrierAgent: [
          { validator: validatorThirdPartyCarrierAgent, trigger: 'change' }
        ],
        portOfLoading: [
          { validator: validatorPortOfLoading, trigger: 'change' }
        ],
        portOfDischarge: [
          { validator: validatorPortOfDischarge, trigger: 'change' }
        ],
        portOfDestination: [
          { validator: validatorPortOfDestination, trigger: 'change' }
        ],
        cargoType: [
          { validator: validatorCargoType, trigger: 'change' }
        ],
        thirdPartyPaymentMethod: [
          { validator: validatorThirdPartyPaymentMethod, trigger: 'change' }
        ],
        thirdPartyBlType: [
          { validator: validatorThirdPartyBlType, trigger: 'change' }
        ],
        sailingDate: [
          { validator: validatorSailingDate, trigger: 'change' }
        ],
        dispatchingPlaceCode: [
          { validator: validatorDispatchingPlaceCode, trim: 'change' }
        ],
        dispatchingImo: [
          { validator: validatorImo, trim: 'blur' }
        ],
        blNumber: [
          { validator: blNumber, trim: 'blur' }
        ]
      }
    }
  },
  computed: {
    isShangHai() {
      return this.form.portOfLoading === 'CNSHA'
    },
    isQingDao() {
      return this.form.portOfLoading === 'CNTAO'
    },
    getOptions() {
      return (name) => {
        if (this.isSeaHouseChannel) {
          return this.seaHouseCache[name] || []
        } else if (this.isWseChannel) {
          return this.wseCache[name] || []
        } else if (this.isRongeTong) {
          return this.rongeTong[name] || []
        } else {
          return []
        }
      }
    },
    isSeaHouseChannel() { // 是否海管家通道
      return this.channel === 1 && !this.commonInfo.combinedManifest && this.commonInfo.showSeaHouseChannel
    },
    isWseChannel() { // 是否未斯通道
      return (this.channel === 2 && !this.commonInfo.combinedManifest && this.commonInfo.showSeaHouseChannel)
    },
    isRongeTong() { // 是否是荣e通
      return this.channel === 3 && !this.commonInfo.combinedManifest && this.commonInfo.showSeaHouseChannel
    },
    labelStyle() {
      return (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) ? 'required-label' : ''
    },
    labelStyleExcludeWse() {
      return this.isSeaHouseChannel ? 'required-label' : ''
    },
    isOocl() { // OOCL—东方海外 单独处理
      // 荣e通,不需要单独处理
      if (this.isRongeTong) {
        return false
      }
      return this.form.thirdPartyCarrier && this.form.thirdPartyCarrier === 'OOCL'
    },
    agentIsOocl() {
      return this.form.thirdPartyCarrierAgent && (this.form.thirdPartyCarrierAgent === 'DF_HAI_WAI' || this.form.thirdPartyCarrierAgent === 'OOCL')
    },
    importDifferenceField() {
      if (!this.job) return {}
      return this.job.differencePrePlanFields || {}
    }
  },
  watch: {
    job(newVal) {
      if (newVal && !this.isEdit) {
        this.onShow()
      }
      if (this.action === 'add' || this.action === 'split' || this.action === 'copy') {
        this.syncTagData()
      }
      this.editInit()
    },
    form(newVal) {
      if (this.manifestInfos.length === 1 && this.manifestInfos[0].uuid === '') {
        Object.keys(this.manifestInfos[0]).forEach(key => {
          if (newVal[key]) {
            this.manifestInfos[0][key] = newVal[key]
          }
        })
      }
      this.$emit('update:manifestInfo', newVal)
    },
    'job.uuid'(newVal) {
      // 刷新验证规则
      this.$refs['myForm'].clearValidate()
    },
    manifestInfo(newVal) {
      this.switchInfo(newVal)
    },
    isSeaHouseChannel() {
      this.init()
      // 刷新验证规则
      this.$refs['myForm'].clearValidate()
    },
    isWseChannel() {
      this.init()
      // 刷新验证规则
      this.$refs['myForm'].clearValidate()
    },
    isRongeTong() {
      this.init()
      // 刷新验证规则
      this.$refs['myForm'].clearValidate()
    },
    channel() {
      this.init()
    },
    'form.mblNo'() {
      this.mblCheck()
    },
    'form.bargeVessel'() {
      this.vesselCheck()
    },
    'form.bargeVoyage'() {
      this.voyageCheck()
    },
    'form.portOfLoading'() {
      if (this.isSeaHouseChannel) {
        this.form.portOfLoading = 'CNSHA'
      }
    }
  },
  created() {
    if (this.job.uuid) {
      this.onShow()
    }
    this.editInit()
  },
  methods: {
    mblCheck() {
      if (this.form.mblNo && (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong)) {
        this.form.mblNo = String(this.form.mblNo).trim().toUpperCase()
      }
    },
    vesselCheck() {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        this.form.bargeVessel = this.form.bargeVessel.replace(/^[\s\n\r]+|[\s\n\r]+$/g, '').toUpperCase()
        if (this.form.bargeVessel.length > 35) {
          this.form.bargeVessel.slice(0, 35)
        }
      }
    },
    voyageCheck() {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        this.form.bargeVoyage = this.form.bargeVoyage.replace(/^[\s\n\r]+|[\s\n\r]+$/g, '').toUpperCase()
        if (this.isRongeTong) {
          this.form.bargeVoyage = this.form.bargeVoyage.length > 20 ? this.form.bargeVoyage.slice(0, 20) : this.form.bargeVoyage
        }
      }
    },
    async editInit() {
      // 获取配置参数
      this.commonInfo.combinedManifest = Number(this.context.config.get('CombinedManifest')) === 1
      this.showJudgmentOfVoyageNo = Number(this.context.config.get('JudgmentOfVoyageNo')) === 1
      this.editVoyageMode = Number(this.context.config.get('EditVoyageMode')) === 1
      this.editInputVesselModel()
      this.blModeList = PrePlanBookingUtil.getBlModelList()
      await this.init()
      this.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
      this.currentVessel = this.vesselList.filter(p => p.englishName === this.form.bargeVessel)[0]
      // 走api的不显示海管家的弹框，走平台公用的【2代表吉联新】
      this.commonInfo.showSeaHouseChannel = this.context.config.get('PreplanEDIApiOpen').indexOf('2') === -1
      this.getVoyageByVessel()
    },
    async init(loadingPortCode = '') {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        if (this.isSeaHouseChannel || this.isWseChannel) {
          await queryListByChannelDataType({ platformChannelCode: 'seaHouse', dataType: 'seaport' }).then(res => {
            const obj = res.data
            if (obj) {
              this.seaHouseCache.seaports = obj['seaport']
              this.seaHouseCache.ooclSeaports = obj['ooclSeaport']
              this.wseCache.seaports = obj['seaport']
              this.wseCache.ooclSeaports = obj['ooclSeaport']
            }
          })
        }
        if (this.isSeaHouseChannel) {
          if (!this.seaHouseCache.load) {
            this.thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('seaHouse')
            this.seaHouseCache.carrierCompanyList = this.thirdPartyMappingUtil.getListByDataType('carrier')
            this.seaHouseCache.carrierAgentCompanyList = this.thirdPartyMappingUtil.getListByDataType('carrierAgent')
            this.seaHouseCache.shippingTerms = this.thirdPartyMappingUtil.getListByDataType('freightTerm')
            this.seaHouseCache.paymentTerms = this.thirdPartyMappingUtil.getListByDataType('paymentMethod')
            this.seaHouseCache.cargoTypes = this.thirdPartyMappingUtil.getListByDataType('cargoType')
            this.seaHouseCache.blModeList = this.thirdPartyMappingUtil.getListByDataType('blType')
            this.seaHouseCache.portOfLoadingSeaports = this.seaHouseCache.seaports
            this.seaHouseCache.placeOfDispatchSeaports = this.seaHouseCache.seaports
            // CARGO-35634 预配舱单-增加覆盖船公司/船代&新增接口对接
            this.seaHouseCache.load = true
          }
          // 通道为海管家时，运输条款固定并且不可编辑CARGO-31020
          this.form.thirdPartyFreightTerm = 'CY-CY'
          // 签发地点写死
          this.form.signPlaceBL = 'SHANGHAI|CNSHA'
          this.form.portOfLoading = 'CNSHA'
        }
        if (this.isWseChannel) {
          if (loadingPortCode && (loadingPortCode === 'CNSHA' || loadingPortCode === 'CNTAO')) {
            this.form.portOfLoading = loadingPortCode
          }
          const ifSh = this.form.portOfLoading === 'CNSHA'
          const filterValue = ifSh ? 'sh' : 'qd'
          this.thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('wse')
          this.wseCache.carrierCompanyList = this.thirdPartyMappingUtil.getListByDataType('carrier').filter(t => t.filterValue === filterValue)
          this.wseCache.carrierAgentCompanyList = this.thirdPartyMappingUtil.getListByDataType('carrierAgent').filter(t => t.filterValue === filterValue)
          this.wseCache.cargoTypes = this.thirdPartyMappingUtil.getListByDataType('cargoType')
          this.wseCache.portOfLoadingSeaports = PrePlanUtil.SEA_PORT.filter(e => (e.code === 'CNTAO' || e.code === 'CNSHA'))
          this.wseCache.placeOfDispatchSeaports = this.seaHouseCache.seaports
          this.form.signPlaceBL = ''
          // 未斯运费条款显示跟海管家一致
          const tempUtil = await ThirdPartyMappingUtil.getInstance('seaHouse')
          this.wseCache.paymentTerms = tempUtil.getListByDataType('paymentMethod')
          this.wseCache.blModeList = tempUtil.getListByDataType('blType')
        }
        if (this.isRongeTong) {
          if (!this.form.thirdPartyFreightTerm) {
            this.form.thirdPartyFreightTerm = 'CY-CY'
          }
          if (loadingPortCode && (loadingPortCode === 'CNSHA' || loadingPortCode === 'CNTAO')) {
            this.form.portOfLoading = loadingPortCode
          }
          const ifSh = this.form.portOfLoading === 'CNSHA'
          const filterValue = ifSh ? 'sh' : 'qd'
          this.thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('rongeTong')
          this.rongeTong.shippingTerms = this.thirdPartyMappingUtil.getListByDataType('freightTerm')
          this.rongeTong.carrierCompanyList = this.thirdPartyMappingUtil.getListByDataType('carrier').filter(t => t.filterValue === filterValue)
          this.rongeTong.carrierAgentCompanyList = this.thirdPartyMappingUtil.getListByDataType('carrierAgent').filter(t => t.filterValue === filterValue)
          this.rongeTong.cargoTypes = this.thirdPartyMappingUtil.getListByDataType('cargoType').filter(t => t.filterValue === filterValue)
          this.rongeTong.portOfLoadingSeaports = PrePlanUtil.SEA_PORT.filter(e => (e.code === 'CNTAO' || e.code === 'CNSHA'))
          this.form.signPlaceBL = ''
          const tempUtil = await ThirdPartyMappingUtil.getInstance('rongeTong')
          this.rongeTong.paymentTerms = tempUtil.getListByDataType('paymentMethod')
          this.rongeTong.blModeList = tempUtil.getListByDataType('blType')
          await queryListByChannelDataType({ platformChannelCode: 'rongeTong', dataType: 'seaport' }).then(res => {
            const obj = res.data
            if (obj) {
              this.rongeTong.seaports = obj['seaport']
            }
          })
          this.rongeTong.placeOfDispatchSeaports = ifSh ? this.rongeTong.seaports : this.rongeTong.placeOfDispatchSeaportsQd
        }
      } else {
        this.form.masterBLFreightTermTootip = this.job.freightTerm
      }
    },
    reloadPort() {
      if (!this.isSent) {
        const carrierCompany = this.getOptions('carrierCompanyList').find(e => e.code === this.form.thirdPartyCarrier)
        if (!carrierCompany) {
          this.form.thirdPartyCarrier = ''
        }
        const carrierAgentCompany = this.getOptions('carrierAgentCompanyList').find(e => e.code === this.form.thirdPartyCarrierAgent)
        if (!carrierAgentCompany) {
          this.form.thirdPartyCarrierAgent = ''
        }
        const cargoType = this.getOptions('cargoTypes').find(e => e.code === this.form.cargoType)
        if (!cargoType) {
          this.form.cargoType = ''
        }
        this.form.dispatchingPlaceCode = ''
      }
    },
    async portOfLoadingHandler(p) {
      this.form.portOfLoading = p.value
      await this.init()
      this.reloadPort()
    },
    // job切换
    async onShow() {
      const manifestInfos = await new Job(this.job).getManifestInfos()
      if (manifestInfos && manifestInfos.length > 0) {
        this.form = manifestInfos[0]
        this.isSent = PrePlanBookingUtil.isSent(manifestInfos[0])
      } else {
        if (!this.isEdit) {
          this.form = new ManifestInfo().fillDefaultValue().getData()
          this.isSent = PrePlanBookingUtil.isSent(this.form)
        }
      }
      if (this.isSeaHouseChannel) {
        this.form.thirdPartyFreightTerm = 'CY-CY'
      } else if (this.isRongeTong) {
        this.form.thirdPartyFreightTerm = this.form.thirdPartyFreightTerm ? this.form.thirdPartyFreightTerm : 'CY-CY'
      } else {
        this.form.masterBLFreightTermTootip = this.job.freightTerm
      }
    },
    // 客户信息切换
    switchInfo(manifestInfo) {
      Object.keys(this.form).forEach(key => {
        if (key === 'jobUuid' ||
           key === 'mblNo' ||
           key === 'portOfLoading' ||
           key === 'portOfDischarge' ||
           key === 'portOfDestination' ||
           key === 'cargoType' ||
           key === 'masterBLFreightTermTootip' ||
           key === 'masterBLFreightTerm' ||
           key === 'placeOfPayment' ||
           key === 'sailingDate' ||
           key === 'bargeVessel' ||
           key === 'bargeVoyage' ||
           key === 'blNumber' ||
           key === 'signPlaceBL' ||
           key === 'signDateBL' ||
           key === 'shippingCompany' ||
           key === 'carrierAgent' ||
           key === 'blType') {
          if (manifestInfo[key] !== undefined && manifestInfo[key] === '') {
            // manifestInfo[key] = this.form[key]
          }
        }
      })
      this.form = manifestInfo
      this.isSent = PrePlanBookingUtil.isSent(manifestInfo)
      if (this.isSeaHouseChannel) {
        this.form.thirdPartyFreightTerm = 'CY-CY'
      } else if (this.isRongeTong) {
        this.form.thirdPartyFreightTerm = this.form.thirdPartyFreightTerm ? this.form.thirdPartyFreightTerm : 'CY-CY'
      }
    },
    onVesselSelectionChange(data) {
      this.currentVessel = data
      this.form.bargeVessel = data.value
      this.getVoyageByVessel()
      if (data.value && data.uuid) {
        this.form.imo = this.currentVessel.imoCode
      } else {
        this.form.imo = ''
      }
    },
    async getVoyageByVessel() {
      if (this.currentVessel && this.currentVessel.vesselId) {
        this.optionsVoyages = await Voyage.getVoyage(this.currentVessel.vesselId)
        this.editInputVesselModel()
      } else {
        this.optionsVoyages = []
      }
    },
    /**
   * 实现自动带出V.，并且录入时追加数据，而不是覆盖
   */
    txtVoyageFocusInHandler() {
      let value = 'V.'
      if (!this.showJudgmentOfVoyageNo) {
        value = ''
      }
      if (this.form.bargeVoyage) {
        value = this.form.bargeVoyage
        this.form.bargeVoyage = ''
      }
      this.$nextTick(() => {
        this.form.bargeVoyage = value
        const elSelect = this.$refs.voyageFlight.$refs.advanceSelectRef
        const innerInput = elSelect.$children[0].$refs.input
        innerInput.value = this.form.bargeVoyage
      })
    },
    onVoyageFlightChange(data) {
      this.form.bargeVoyage = data.value
      this.voyageCheck()
    },
    cmbreleaseTypeMBLChangeHandler(value) {
      this.form.blNumber = Number(value) === 1 ? 'THREE' : 'ONE'
    },
    // 回执查询
    handleReceipt() {
      this.$emit('handleReceipt')
    },
    // 复制、新增同步其他页签数据
    syncTagData() {
      this.editInit()
      this.isSent = false
    },
    // 编辑时同步各页签数据
    newCreateSync() {
      if (!this.job.version) {
        this.form.jobUuid = this.job.jobNo
        this.form.carrierAgent = this.job.carrierAgentId
        this.form.shippingCompany = this.job.carrierId
        this.form.portOfLoading = this.job.loadingPortCode
        this.form.portOfDischarge = this.job.dischargingPortCode
        this.form.portOfDestination = this.job.destinationPortCode
        this.form.cargoType = this.job.cargoType
        this.form.masterBLFreightTermTootip = this.job.freightTerm
        this.form.masterBLFreightTerm = this.job.paymentTermMBL
        this.form.sailingDate = this.job.etd
        this.form.placeOfPayment = this.job.seaCargoDoc[0]?.paymentPlaceBL
        this.form.mblNo = this.job.mbl
        this.form.bargeVessel = this.job.vessel
        this.form.bargeVoyage = this.job.voyageFlight
        if (this.job.signMBL) {
          this.form.signPlaceBL = this.job.seaCargoDoc[0]?.signPlaceBL
          this.form.signDateBL = this.job.seaCargoDoc[0]?.signDateBL
          this.form.blType = this.job.seaCargoDoc[0]?.releaseType + ''
          this.form.blNumber = this.job.seaCargoDoc[0]?.blNumber
        }
      }
    },
    /**
     * 编辑船名航次模式
     */
    editInputVesselModel() {
      if (this.form) {
        if (this.form.bargeVoyage && this.optionsVoyages) {
          const curVoyage = this.optionsVoyages.filter(p => p.voyageNo === this.form.bargeVoyage)[0]
          if (!curVoyage) {
            this.optionsVoyages.push({ voyageNo: this.form.bargeVoyage })
          }
        }
      }
    },
    // 更改船司
    changeThirdPartyCarrier() {
      if (this.isWseChannel) {
        if (!(this.isOocl && (this.isQingDao || this.isShangHai))) this.form.imo = ''
        return
      }
      if (!this.form.thirdPartyCarrier) {
        return
      }
      this.$emit('handleCarrier')
      if (!this.form.portOfDischarge) {
        return
      }
      if (this.isOocl) {
        const port = this.getOptions('ooclSeaports') ? this.getOptions('ooclSeaports').filter(p => p.code === this.form.portOfDischarge)[0] : null
        if (!port) {
          this.form.portOfDischarge = ''
        }
      } else {
        const port = this.getOptions('seaports') ? this.getOptions('seaports').filter(p => p.code === this.form.portOfDischarge)[0] : null
        if (!port) {
          this.form.portOfDischarge = ''
        }
      }
    },
    changeMbl() {
      this.$refs.myForm.validate()
    },
    cleanUpAll() {
      this.$refs['myForm'].clearValidate()
    }
  }
}
</script>

<style lang="scss" scoped>
.manifest-info{
    .el-form{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: flex-start;
        /deep/ .el-form-item{
            margin-bottom: 10px !important;
            .el-form-item__content{
                width: 200px;
              margin-bottom: 8px;
                .el-input{
                    width: 100%;
                    &.short{
                      width: 155px;
                    }
                }
                .search-btn{
                  width: 40px;
                  height: 28px;
                  box-sizing: border-box;
                  vertical-align: top;
                  background-color: #1F75D5;
                  border-radius: 5px;
                  margin-left: 5px;
                  color: #FFF;
                  text-align: center;
                  cursor: pointer;
                  display: inline-block;
                }
            }

        }
    }
  /deep/ .required-label .el-form-item__label{
    color: #1F75D5 !important;
  }
  .red-border {
    /deep/ .el-input__inner,
    /deep/ .el-textarea__inner {
      border: 1px solid red !important;
    }
  }
}
</style>
